import apiClient from '@/lib/api-client';
import { ApiError } from '@/model/ApiError';
import {
    Responsible,
    ResponsibleDelete,
    ResponsibleUpdate,
} from '@/model/Responsible';
import router from '@/router';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({ namespaced: true, preserveState: false })
export default class ResponsibleStorage extends VuexModule {
    error: ApiError | null = null;

    responsibles: Responsible[] = new Array<Responsible>();

    @Mutation
    setError(newError: ApiError | null): void {
        this.error = newError;
    }

    @Mutation
    setResponsibles(newResponsibles: Responsible[]): void {
        this.responsibles = newResponsibles;
    }

    @Action
    create(request: ResponsibleUpdate): Promise<void> {
        return apiClient
            .post(`/events/${request.eventId}/responsible`, {
                name: request.name,
                color: request.color,
            })
            .then(() => {
                this.context.commit('setError', null);
            })
            .catch((error) => {
                this.context.commit('setError', error);
                return Promise.reject();
            });
    }

    @Action
    fetchResponsibles(eventId: number): Promise<void> {
        return apiClient
            .get(`/events/${eventId}/responsible`)
            .then((data) => {
                this.context.commit('setError', null);
                this.context.commit('setResponsibles', data);
            })
            .catch((error) => {
                if (error?.key === 'security.permission.denied') {
                    router.push({ name: 'NotFound' });
                }

                this.context.commit('setError', error);
                return Promise.reject();
            });
    }

    @Action
    update(request: ResponsibleUpdate): Promise<void> {
        return apiClient
            .put(`/events/${request.eventId}/responsible/${request.id}`, {
                name: request.name,
                color: request.color,
                order: request.order,
            })
            .then(() => {
                this.context.commit('setError', null);
            })
            .catch((error) => {
                this.context.commit('setError', error);
                return Promise.reject();
            });
    }

    @Action
    delete(request: ResponsibleDelete): Promise<void> {
        return apiClient
            .delete(
                `/events/${request.eventId}/responsible/${request.responsibleId}`,
            )
            .then(() => {
                this.context.commit('setError', null);
            })
            .catch((error) => {
                this.context.commit('setError', error);
                return Promise.reject();
            });
    }

    get getError(): ApiError | null {
        return this.error;
    }

    get getResponsibles(): Responsible[] {
        return this.responsibles;
    }
}
